import React, { useState, useEffect } from 'react';
import NewNotificationBar from './NewNotificationBar';
import notificationsService from '../services/notificationsService';
import './NotificationDisplay.css';

const NotificationDisplay = () => {
  const [isNotificationVisible, setIsNotificationVisible] = useState(false);
  const [notificationCount, setNotificationCount] = useState(0);

  useEffect(() => {
    // Check for notifications when component mounts
    checkForNotifications();
    
    // Set up polling to check for new notifications every 30 seconds
    const interval = setInterval(checkForNotifications, 30000);
    
    return () => clearInterval(interval);
  }, []);

  const checkForNotifications = async () => {
    try {
      console.log('🔍 NotificationDisplay: Checking for notifications...');
      const count = await notificationsService.getNotificationCount();
      console.log('📊 NotificationDisplay: Notification count:', count);
      
      setNotificationCount(count);
      const shouldShow = count > 0;
      console.log('👁️ NotificationDisplay: Should show notification:', shouldShow);
      setIsNotificationVisible(shouldShow);
    } catch (error) {
      console.error('❌ NotificationDisplay: Error checking notifications:', error);
      setIsNotificationVisible(false);
    }
  };

  const handleCloseNotification = () => {
    setIsNotificationVisible(false);
    // Refresh notification count after closing
    setTimeout(checkForNotifications, 1000);
  };

  // Temporary: Force show for testing
  const forceShow = true;
  
  console.log('🎯 NotificationDisplay: Rendering with forceShow =', forceShow, 'isNotificationVisible =', isNotificationVisible);
  
  return (
    <div className="notification-display-container">
      <NewNotificationBar 
        isVisible={forceShow || isNotificationVisible} 
        onClose={handleCloseNotification} 
      />
    </div>
  );
};

export default NotificationDisplay;
